/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import SiteAddress from 'components/SiteAddress/SiteAddress';
import ElectroMessageBarCont from 'forms/components/inputs/ElectroMessageBarCont/ElectroMessageBarCont';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {|
  actionDrawerStore: TypeActionDrawerStore,
  response: Object,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class ChangeAssetLocationSuccess extends React.Component<*> {
  get siteName() {
    const response: Object = this.props.response;
    const names: Array<string> = [response.location.site.name];

    if (response.location.building.name) {
      names.unshift(response.location.building.name);
    }

    if (response.location.room.name) {
      names.unshift(response.location.room.name);
    }

    if (response.location.workspace.name) {
      names.unshift(response.location.workspace.name);
    }

    return names.join(', ');
  }

  render(): React.Node {
    const { t, actionDrawerStore, response }: TypeProps = this.props;

    const parentAsset: Array<*> = response.updated_assets.filter(asset => {
      return !asset.is_child;
    });
    const childAsset: Array<*> = response.updated_assets.filter(asset => {
      return asset.is_child;
    });
    const orphanedAssets: Array<*> = response.orphaned_assets.filter(asset => {
      return asset.is_child;
    });

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <div className={styles['success-details']}>
            {response.type ? (
              response.is_child ? (
                <React.Fragment>
                  <h3>{t('general:assets.child_asset_location_changed')}</h3>
                  <p>{t('general:assets.messages.child_asset_location_changed')}</p>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <h3>{t('general:assets.parent_asset_location_changed')}</h3>
                  <p>{t('general:assets.messages.parent_asset_location_changed')}</p>
                </React.Fragment>
              )
            ) : (
              <React.Fragment>
                <h3>{t('general:assets.location_changed')}</h3>
                <p>{t('general:assets.messages.location_changed')}</p>
              </React.Fragment>
            )}
            {response.type && (Array.isArray(parentAsset) && Boolean(parentAsset.length)) && (
              <React.Fragment>
                <ul>
                  <li>
                    <b>{t('general:assets.parent_asset')}:</b>
                  </li>

                  {parentAsset.map(asset => {
                    return (
                      <li key={asset.asset_number}>
                        {`${asset.asset_number},
                                                    ${asset.manufacturer},
                                                    ${asset.model}`}
                      </li>
                    );
                  })}
                </ul>
              </React.Fragment>
            )}
            {response.type && (Array.isArray(childAsset) && Boolean(childAsset.length)) && (
              <React.Fragment>
                <ul>
                  <li>
                    <b>{t('general:assets.child_asset')}:</b>
                  </li>
                  {childAsset.map(asset => {
                    return (
                      <li key={asset.asset_number}>
                        {`${asset.asset_number},
                                                    ${asset.manufacturer},
                                                    ${asset.model}`}
                      </li>
                    );
                  })}
                </ul>
              </React.Fragment>
            )}
            <ul>
              <li>
                <b>{t('general:assets.labels.new_location')}:</b>
              </li>
              <li>
                <SiteAddress {...response.location.site.address} siteName={this.siteName} />
              </li>
            </ul>
            <ul>
              <li>
                {`${t('general:labels.belonging_to')} ${response.location.company.name}
                                    company, and ${response.location.site.name} site.`}
              </li>
            </ul>
          </div>
        </div>
        {response.type && (Array.isArray(orphanedAssets) && Boolean(orphanedAssets.length)) && (
          <React.Fragment>
            <hr />
            <ActionDrawerBlock gutters={true} divider={false}>
              <ElectroMessageBarCont
                props={{
                  variant: 'warning',
                  message: t('general:assets.messages.orphaned'),
                  linkto: {
                    pathname: `/assets/account/${response.trading_account.id}/orphaned`,
                    state: orphanedAssets
                      .map(a => {
                        return a.asset_number;
                      })
                      .join('|'),
                  },
                }}
              />
            </ActionDrawerBlock>
          </React.Fragment>
        )}
        <div className={styles['action-drawer-actions']}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
